import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.boundHandleKeyboard = this.handleKeyboard.bind(this)
    document.addEventListener('keydown', this.boundHandleKeyboard)
  }

  disconnect() {
    document.removeEventListener('keydown', this.boundHandleKeyboard)
  }

  open(event) {
    event.preventDefault()
    this.modalTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add('hidden')
    document.body.style.overflow = ''
  }

  backdropClick(event) {
    if (event.target === event.currentTarget) {
      this.close(event)
    }
  }

  handleKeyboard(event) {
    if (this.modalTarget.classList.contains('hidden')) return
    if (event.key === 'Escape') this.close()
  }
}
